import React from "react";
import styled from "styled-components";
import get from "lodash/get";

import CameraAltIcon from "@mui/icons-material/CameraAlt";

import Button from "../shared/Button";
import EstateItemHeader from "../estates/EstateItemHeader";

const EstateAssociationItem = ({
  estate,
  showDetail,
  handleSelect,
  isSelected,
}) => {
  const {
    id,
    name,
    address,
    number,
    box,
    floor,
    zip,
    city,
    country,
    displayStatusId,
    purpose,
    purposeStatus,
    price,
    currency,
    pictures = [],
    category,
    // canHaveChildren,
    // parentId,
    room,
  } = estate;

  // const isProject = canHaveChildren && !parentId;
  const computedAddress = [address, number, box, floor]
    .filter(Boolean)
    .join(" ");
  const fullAddress = [computedAddress, zip, city].filter(Boolean).join(", ");
  const imageUrl = get(pictures, [0, "urlSmall"], "");

  return (
    <StyleWrapper className="estate__list__item d-flex align-items-center">
      <div className="estate__list__item-img">
        <img src={imageUrl} alt="" />
        <span className={`purpose purpose-${get(purpose, "id")}`}>
          {get(purpose, "name")}
        </span>
        <span className="pictures">
          <CameraAltIcon htmlColor="var(--white)" />
          {pictures.length}
        </span>
      </div>
      <div className="estate__list__item-info">
        <EstateItemHeader
          isUnitView
          actionBtnAtTop
          id={id}
          name={name}
          category={get(category, "name")}
          purposeStatus={get(purposeStatus, "name")}
          displayStatusId={displayStatusId}
          fullAddress={fullAddress}
          country={get(country, "name")}
          onClickTitle={showDetail}
          price={price}
          currency={currency}
          displayPurposeStatus
          // isProject={isProject}
          room={room}
          actions={
            <Button
              className="associate-btn"
              color={isSelected ? "success" : "primary"}
              variant="contained"
              icon={
                <img
                  src={`/assets/icons/doc-${
                    isSelected ? "" : "not-"
                  }processed.svg`}
                  alt=""
                />
              }
              onClick={() => handleSelect(estate)}
            >
              {isSelected ? "Associé" : "Associer"}
            </Button>
          }
        />
      </div>
    </StyleWrapper>
  );
};

const StyleWrapper = styled.div`
  &.estate__list__item {
    height: 164px;
    width: 1100px;
    border-radius: 12px;
    background-color: var(--white);
    padding: 15px;
    box-shadow: 0px 0px 10px -6px rgba(130, 130, 130, 1);

    &:first-child {
      margin-top: 10px;
    }

    &:last-child {
      margin-bottom: 10px;
    }

    .estate__list__item-img {
      position: relative;

      img {
        width: 216px;
        height: 140px;
        border-radius: 3px;
      }

      & .purpose {
        position: absolute;
        top: 10px;
        left: 10px;
        border-radius: 3px;
        padding: 2px 10px;

        color: var(--white);
        background-color: var(--red-color);
        text-transform: capitalize;
        font-size: 13px;
        font-weight: 700;

        &.purpose-2 {
          background-color: var(--blue-dark);
        }

        &.purpose-3 {
          // TODO: confirmer la couleur du background pour la vente en viager
        }
      }

      & .pictures {
        position: absolute;
        display: flex;
        align-items: center;
        left: 10px;
        bottom: 10px;
        color: var(--white);
        font-size: 10px;

        & > svg {
          font-size: 12px;
          margin-right: 5px;
        }
      }
    }

    .estate__list__item-info {
      margin-left: 30px;
      margin-right: 15px;
      flex-grow: 1;

      .name-container {
        margin-bottom: 15px;
      }

      .associate-btn {
        font-size: 14px;
        font-weight: 700;
        border-radius: 10px;
        padding: 6px 20px;

        img {
          margin-right: 5px;
        }

        &.primary {
          background-color: var(--blue-dark);
        }
      }
    }
  }
`;

export default EstateAssociationItem;
